import { useEffect, useRef } from 'react';
import type { PersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import {
  MobileModalDebugEvent,
  captureMobileModalEnvironment,
} from '@/hooks/telemetry/mobile-modal-debug';

interface UseCstretchmodalStateTransitionLogInput {
  debugLogger: PersistentDebugLogger;
  debugName?: string;
  debugState: Record<string, unknown>;
}

export function useCstretchmodalStateTransitionLog({
  debugLogger,
  debugName,
  debugState,
}: UseCstretchmodalStateTransitionLogInput): void {
  const previousDebugStateRef = useRef<Record<string, unknown> | null>(null);

  useEffect((): void => {
    if (!debugName) {
      return;
    }

    const previousState = previousDebugStateRef.current;
    const payload = {
      environment: captureMobileModalEnvironment(),
    };

    if (previousState == null) {
      debugLogger.logMarker({
        name: MobileModalDebugEvent.StretchModalStateInitialized,
        payload: {
          state: debugState,
          ...payload,
        },
      });
      previousDebugStateRef.current = debugState;
      return;
    }

    debugLogger.logStateTransition({
      name: MobileModalDebugEvent.StretchModalStateChanged,
      from: previousState,
      to: debugState,
      payload,
    });
    previousDebugStateRef.current = debugState;
  }, [debugLogger, debugName, debugState]);
}
